import DeeplinkScene from './DeeplinkScene'
export default DeeplinkScene